"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var footerBaseTheme = function (breakpoints) {
    var _a, _b, _c, _d, _e, _f, _g;
    var MAX_XXS = breakpoints.MAX_XXS, MAX_XS = breakpoints.MAX_XS, MAX_S = breakpoints.MAX_S, DESKTOP_ONLY = breakpoints.DESKTOP_ONLY, TABLET_MAX = breakpoints.TABLET_MAX, MAX_M = breakpoints.MAX_M, MAX_L = breakpoints.MAX_L;
    return ({
        footer: (_a = {
                display: "block",
                order: 4,
                paddingBottom: "1rem"
            },
            _a[DESKTOP_ONLY] = {
                padding: "1rem 5.5rem",
            },
            _a[TABLET_MAX] = {
                padding: "1rem 3.5rem 2rem 3.5rem",
            },
            _a[MAX_L] = {
                padding: "1rem 2rem",
                display: "grid",
                flexWrap: "wrap",
                gridTemplateColumns: "100%",
            },
            _a[MAX_S] = {
                padding: "1rem",
                "& MuiTypography": {
                    marginLeft: "0px",
                }
            },
            _a),
        footerContainer: (_b = {
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "calc(50% - 2rem) calc(50% - 2rem)",
                gridColumnGap: "2rem"
            },
            _b[MAX_M] = {
                gridTemplateColumns: "100%",
            },
            _b),
        footerLinkWrapper: {
            order: 2
        },
        footerLinkContainer: (_c = {
                textDecoration: "none",
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr"
            },
            _c[MAX_XS] = {
                gridTemplateColumns: "calc(50% - 0.5rem) calc(50% - 0.5rem)",
                gridColumnGap: "1rem",
            },
            _c[MAX_XXS] = {
                gridTemplateColumns: "100%",
            },
            _c),
        footerLinkItemWrapper: {
            fontSize: "15px",
            marginTop: "5px",
            marginBottom: "1rem",
            marginRight: "1.25rem",
            marginLeft: "0",
            "& p": {
                marginTop: "0",
                marginBottom: "0",
            }
        },
        footerRelatedResources: (_d = {
                display: "grid",
                textDecoration: 'none',
                gridTemplateColumns: "1fr 1fr 1fr"
            },
            _d[MAX_XS] = {
                gridTemplateColumns: "1fr 1fr",
            },
            _d[MAX_XXS] = {
                gridTemplateColumns: "100%",
            },
            _d),
        footerRelatedResourcesContainer: {
            order: 3,
        },
        footerLinkHeaderImage: (_e = {
                backgroundRepeat: "no-repeat",
                height: "3rem",
                width: "auto",
                margin: "2rem 0 1rem 0"
            },
            _e[MAX_XS] = {
                height: "auto",
                width: "100%",
            },
            _e),
        footerRelatedResourcesHeader: {
            display: "inline-block",
            fontWeight: "bold",
            fontSize: "19px",
            marginTop: "20px",
        },
        footerRelatedResourcesDescription: {
            fontSize: '0.75rem'
        },
        footerRelatedResourcesText: {
            fontSize: '0.875rem',
            marginBottom: "15px",
            marginLeft: "0px",
            margin: "5px"
        },
        footerSiteNavWrapper: {
            order: 1,
            marginTop: "3rem",
            boxSizing: 'content-box'
        },
        footerSiteNav: (_f = {
                display: "grid",
                textDecoration: 'none',
                gridTemplateColumns: "1fr 1fr 1fr"
            },
            _f[MAX_XS] = {
                gridTemplateColumns: "1fr 1fr",
            },
            _f[MAX_XXS] = {
                gridTemplateColumns: "100%",
            },
            _f),
        footerCopyright: (_g = {
                order: 4,
                display: 'flex',
                flexDirection: "column-reverse",
                paddingBottom: "1rem",
                fontSize: "0.6875rem",
                maxWidth: "550px"
            },
            _g[MAX_S] = {
                marginTop: "2rem",
            },
            _g),
        footerSiteNavHeader: {
            textTransform: "capitalize",
            display: "inline-block",
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: "19px",
            marginTop: "20px",
            marginRight: "10px"
        },
        footerLinkHeader: {
            display: "inline-block",
            fontWeight: "bold",
            fontSize: "19px",
            marginTop: "20px",
        },
        footerSiteNavText: {
            fontSize: 14,
            textDecoration: 'none',
            marginBottom: "15px",
            marginLeft: "0px",
            margin: "5px",
        },
        footerLinkItem: {
            display: 'inline-block'
        }
    });
};
exports.default = footerBaseTheme;
//# sourceMappingURL=footer.js.map